import CardHeader from "../UI/Cards/CardHeader";
import { cardListItem } from "../UI/Cards/CardListItem";
import HomePageLink from "./HomePageLink";

export default function HomePageCard({
  icon,
  title,
  cardItems
}: {
  icon?: React.ReactNode;
  title: string;
  cardItems: cardListItem[];
}) {
  return (
    <div className="flex flex-col gap-[48px]">
      {icon && <CardHeader cardTitle={title} icon={icon} />}

      <div className="flex flex-col gap-[24px]">
        {cardItems
          .filter((app) => app.isModuleEnabled)
          .map((app, id) => (
            <HomePageLink
              key={`${app.appRef}-${id}`} // adding id because both legacy and new arrival operator have same appRef
              redirectUrl={app.redirectUrl}
              icon={app.icon}
              title={app.applicationTitle}
              appRef={app.appRef}
              isSmallCard={app.isSmallCard}
            />
          ))}
      </div>
    </div>
  );
}
